module.exports = __webpack_public_path__ + "static/media/Huawei P8 White.0b246f91.png";